export { default, ManagerTableCellPracticeStatus } from './ManagerTableCellPracticeStatus';